import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';
import { PromotionModel } from '@/models';
import promotionMock from 'tests/__mocks__/mockPromotion';

export default class PromotionService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/promotion');

  async getPromotionById(promotionId: string): Promise<PromotionModel> {
    return this.api.getPromisedJSON(`${PromotionService.baseUrl}/${promotionId}`);
  }
}

export class FakePromotionService {
  async getPromotionById(promotionId: string): Promise<PromotionModel> {
    return new Promise((resolve, reject) => {
      if (!promotionId) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject();
      } else {
        resolve(promotionMock);
      }
    });
  }
}
